.menu {
  display: flex;
  flex-direction: column;
  min-width: 12rem;
  max-width: 22rem;
  padding: var(--space-1);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-2-5);
  width: 100%;
  min-height: 2.25rem;
  padding: var(--space-1-5) var(--space-2-5);
  border-radius: var(--radius-md);
  color: var(--color-text);
  font-size: var(--font-size-md);
  text-align: left;
  cursor: pointer;
}

.item:hover:not([aria-disabled='true']),
.item:focus-visible,
.item:focus {
  background-color: var(--color-surface-hover);
  outline: none;
}

.item:focus-visible {
  box-shadow: inset 0 0 0 2px var(--color-focus-ring);
}

.item[aria-disabled='true'] {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

.danger {
  color: var(--color-danger-fg);
}

.danger:hover:not([aria-disabled='true']),
.danger:focus {
  background-color: var(--color-danger-bg);
}

.icon {
  display: inline-flex;
  flex-shrink: 0;
  color: var(--color-text-muted);
}

.danger .icon {
  color: currentColor;
}

.icon > svg {
  width: 1.125rem;
  height: 1.125rem;
}

.text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description {
  color: var(--color-text-subtle);
  font-size: var(--font-size-xs);
}

.shortcut {
  margin-left: auto;
  color: var(--color-text-subtle);
  font-size: var(--font-size-xs);
}

.check {
  display: inline-flex;
  width: 1rem;
  margin-left: auto;
  color: var(--color-link);
}

.separator {
  height: 1px;
  margin: var(--space-1) calc(-1 * var(--space-1));
  background-color: var(--color-border);
}

.heading {
  padding: var(--space-2) var(--space-2-5) var(--space-1);
  color: var(--color-text-subtle);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
}
